import { generateHTML } from '@tiptap/core';

import {
  getExtensions,
  isRichtextEmpty,
} from 'approot/shared/richtext/richtext.utils';
import { JSONObject } from 'global/graphql/scalars.type';
import { InfoBoxViewTextBox } from '../../info-box/info-box-view';
import { Settings } from 'approot/shared/richtext/richtext.constants';

export const CAPTION_SETTINGS: Settings = {
  placeholder: 'Add captions here...',
  canChangeBlockType: true,
  canBold: true,
  canItalic: true,
  canUnderline: true,
  canAddLists: true,
  canChangeHistory: true,
  canChangeFonts: true,
  canAddLinks: true,
  canAlignText: true,
  canHighlight: true,
};

export const ComponentCaption = ({
  id,
  caption,
  showCaption,
  isSmall = true,
}: {
  id: string;
  caption: JSONObject;
  showCaption: boolean;
  isSmall?: boolean;
}) => {
  const extensions = getExtensions(CAPTION_SETTINGS);

  return showCaption ? (
    <figcaption>
      <InfoBoxViewTextBox
        id={id}
        isSmall={isSmall}
        richtext={
          isRichtextEmpty(caption) ? '' : generateHTML(caption, extensions)
        }
      />
    </figcaption>
  ) : null;
};
